import { Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'four-oh-four',
  templateUrl: './four-oh-four.component.html',
  standalone: false,
})
export class FourOhFourComponent {
  @Input() title: string;
  @Input() user: any;
}
